/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast. Keeping custom
* Javascript here makes it easier to update Broadcast. This file is loaded
* near the bottom of layout/theme.liquid.
*/


(function() {
  function updateCartButtonLabels(container) {
    container.querySelectorAll('[data-add-to-cart-label]').forEach((label) => {
      const button = label.closest('button');
      const customLabel = label.dataset.addToCartLabel.trim();

      if (button && !button.disabled && customLabel) {
        label.textContent = customLabel;
      }
    });
  }

  // Broadcast refreshes button text before dispatching this variant event.
  document.addEventListener('theme:variant:change', (event) => {
    if (event.detail?.variant?.available) {
      updateCartButtonLabels(event.target);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    updateCartButtonLabels(event.target);
  });

  // The initial product-form setup can run before this deferred script loads.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateCartButtonLabels(document), {once: true});
  } else {
    updateCartButtonLabels(document);
  }
})();
